// extracted by mini-css-extract-plugin
export var chip = "_d8-0";
export var filterDropdown = "_d8-5";
export var filterItem = "_d8-6";
export var icon = "_d8-1";
export var removeButton = "_d8-3";
export var removeIcon = "_d8-4";
export var separator = "_d8-2";